package com.dignicate.web.data.content.static.home

import com.dignicate.web.data.content.ProductInfoDto
import com.dignicate.web.domain.Language
import com.dignicate.web.domain.LocalizedText
import com.dignicate.web.domain.LocalizedTexts

class ProductsContentSource {
    fun products(): List<ProductInfoDto> {
        return listOf(
            ProductInfoDto(
                id = "flying_word_cards",
                title = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "Flying Word Cards"
                        ),
                        LocalizedText(
                            Language.En,
                            "Flying Word Cards"
                        )
                    )
                ),
                description = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "クライアントサイド技術の研究目的で開発した、リアルタイムアニメーションを活用した単語帳アプリ（Android 向け・無料）です。現在は弊社ブランド（Dignicate, LLC）として細く長く保守を続けています。"
                        ),
                        LocalizedText(
                            Language.En,
                            "An experimental vocabulary app for Android that uses real-time animation to make word learning more interactive. It was originally developed as a client-side technology study and is now maintained under the Dignicate, LLC brand."
                        )
                    )
                ),
                // Android only
                androidLink = "https://play.google.com/store/apps/details?id=net.extendone.rvb"
            ),
            ProductInfoDto(
                id = "e_book_ichos",
                title = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "電子書籍 ήχος"
                        ),
                        LocalizedText(
                            Language.En,
                            "eBook ήχος"
                        )
                    )
                ),
                description = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "“ήχος” はギリシャ語で「音」の意味を持ちます。洋書を音声で朗読することにフォーカスした、新しいスタイルの電子書籍アプリです。パブリックドメインのクラシック作品を中心に、Android / iOS 向けに展開しています。"
                        ),
                        LocalizedText(
                            Language.En,
                            "“ήχος” means “sound” in Greek. It is an e-book reader focused on audio, letting you listen to public-domain classics in English. The app is available on both Android and iOS."
                        )
                    )
                ),
                // Android and iOS
                androidLink = "https://play.google.com/store/apps/details?id=com.dignicate.defire3.development&pli=1",
                iosLink = "https://apps.apple.com/jp/app/%E9%9B%BB%E5%AD%90%E6%9B%B8%E7%B1%8D%CE%AE%CF%87%CE%BF%CF%82/id1233151643"
            ),
            ProductInfoDto(
                id = "other_experiments",
                title = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "その他の取り組み"
                        ),
                        LocalizedText(
                            Language.En,
                            "Other experiments"
                        )
                    )
                ),
                description = LocalizedTexts(
                    listOf(
                        LocalizedText(
                            Language.Ja,
                            "公開アプリ以外にも、モバイルアプリ開発やアーキテクチャの検証を目的としたプロトタイプ開発を継続的に行っています。公開可能な段階になったものから、順次ここに追加していく予定です。"
                        ),
                        LocalizedText(
                            Language.En,
                            "Besides public apps, we continuously prototype mobile applications and architecture ideas for internal research. Once they become stable and useful enough, we plan to introduce them here as new products."
                        )
                    )
                )
            )
        )
    }
}
